import { useSupabaseLoader } from "../../../server/supabase/hooks";

import type { Database } from "../../../__definitions__/database-definitions";
import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import type { UUID } from "../../../utils/uuid";

export type ProgramEngagement = Database["public"]["Views"]["program_engagement"]["Row"];

/**
 * The people that a program's dated, repeating and published Communications with a link were
 * delivered to, and those of them who clicked, with its folders, over all time. Null when no such
 * Communication was delivered to a person.
 */
export const useProgramEngagement = (id: UUID): UseSupabaseLoaderState<ProgramEngagement | null> =>
  useSupabaseLoader(
    async ({ supabase }) => {
      const { data, error } = await supabase
        .from("program_engagement")
        .select("*")
        .eq("id", id)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
    [id],
  );
